import React from "react";
import PropertyTable from "../properties/Properties";
const Properties = () => {
  return (
    <div>
      <PropertyTable />
    </div>
  );
};

export default Properties;
